import React from "react";
import Sortable from "../Svg/Sortable";
interface sortType {
  setSortType: (value: number) => void;
  setSortOrder: (value: boolean) => void;
  sortType: number;
  itemsCount: number;
  sortOrder: boolean;
}

function SortableCard({
  setSortType,
  setSortOrder,
  sortType,
  sortOrder,
  itemsCount,
}: sortType) {
  return (
    <div className="sortable-section  justify-between items-center sm:flex hidden">
      <div className="flex items-center gap-3 text-base">
        <span>
          <Sortable />
        </span>
        <div className="flex items-center gap-5">
          <span className="text-ws-gray-500 ">مرتب سازی:</span>
          <span
            onClick={() => {
              setSortType(1);
              setSortOrder(false);
            }}
            className={`cursor-pointer ${
              sortType === 1 && sortOrder === false
                ? "active text-ws-grayBlue-600"
                : ""
            }`}
          >
            مرتبط‌ترین
          </span>

          <span
            onClick={() => {
              setSortType(3);
              setSortOrder(false);
            }}
            className={`cursor-pointer ${
              sortType === 3 && sortOrder === false
                ? "active text-ws-grayBlue-600"
                : ""
            }`}
          >
            جدید‌ترین
          </span>

          <span
            onClick={() => {
              setSortType(2);
              setSortOrder(false);
            }}
            className={`cursor-pointer ${
              sortType === 2 && sortOrder === false
                ? "active text-ws-grayBlue-600"
                : ""
            }`}
          >
            ارزان‌ترین
          </span>

          <span
            onClick={() => {
              setSortType(2);
              setSortOrder(true);
            }}
            className={`cursor-pointer ${
              sortType === 2 && sortOrder === true
                ? "active text-ws-grayBlue-600"
                : ""
            }`}
          >
            گران‌ترین
          </span>

          <span
            onClick={() => {
              setSortType(4);
            }}
            className={`cursor-pointer ${
              sortType === 4 ? "active text-ws-grayBlue-600" : ""
            }`}
          >
            آفرهای ویژه
          </span>
        </div>
      </div>
      <span className="num-vazir">{itemsCount} کالا</span>
    </div>
  );
}

export default SortableCard;
